import v15Schema, {
  MigrationTypes as V15Types,
} from "../client/schemaVersions/v15.js";
import v16Schema, {
  MigrationTypes as V16Types,
} from "../client/schemaVersions/v16.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V15Types, V16Types>(
  v15Schema,
  v16Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
